import { VenuesDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";

export const useVenues = () => {
  const query = useQuery(VenuesDocument);

  return { ...query, data: query?.data?.venues };
};
